import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import React, { useRef, useState } from 'react';
import { Box, Container, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 20
  },
  container: {
    maxWidth: 1040,
    padding: 0,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2)
    }
  },
  media: {
    width: '95%',
    [theme.breakpoints.down(700)]: {
      width: '100%',
      margin: 'auto'
    }
  },
  gridContainer: {
    borderBottom: '1px solid #707070',
    margin: '0 -12px',
    '&:last-child': {
      borderBottom: 'none'
    },
    cursor: 'pointer'
  },
  title: {
    textAlign: 'start'
  },
  htmlCode: {
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    // '-webkit-line-clamp': 3,
    // overflow: 'hidden',
    whiteSpace: 'pre-line',
    textAlign: 'start',
    '& *': {
      padding: 'revert'
    },
    '& p': {
      margin: 0
    }
  },
  noRecord: {
    fontSize: '24px',
    fontWeight: 500,
    textAlign: 'center'
  },
  wrapContent: {
    position: 'relative',
    [theme.breakpoints.up(959)]: {
      height: '100%'
    }
  },
  textContent: {
    padding: '10px 12px !important',
    display: 'flex',
    alignItems: 'center'
  }
}));

function Drama({ className, profiles }) {
  const classes = useStyles();
  const ref = useRef();

  const [imgIndex, setImgIndex] = useState(0);

  return (
    <div
      className={clsx(classes.root, className)}
      style={{ paddingBottom: profiles?.totalPage > 1 ? 20 : 50 }}
    >
      <Container className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box>
              <img
                className={classes.media}
                src={profiles?.profiles[imgIndex]?.img}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx(classes.wrapContent)}
            innerRef={ref}
          >
            <Box width="100%">
              {profiles?.profiles?.map((other, index) => (
                <Grid
                  container
                  spacing={3}
                  key={index}
                  className={classes.gridContainer}
                  onMouseEnter={() => setImgIndex(index)}
                >
                  <Grid item xs={3} className={classes.textContent}>
                    <Box>
                      <Typography
                        variant="body1"
                        color="inherit"
                        className={classes.title}
                      >
                        {moment(other?.date).format('YYYY')}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={9} className={classes.textContent}>
                    <Box>
                      <span
                        className={clsx(classes.htmlCode, 'ck-content')}
                        dangerouslySetInnerHTML={{ __html: other?.body }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

Drama.propTypes = {
  className: PropTypes.string,
  noticeList: PropTypes.array
};

export default Drama;
